export default __webpack_public_path__ + "static/media/011-cap.34aaa774.svg";